import Toggle from './Toggle';
import { ToggleProps, ToggleCombinedProps } from './Toggle.types';

export type { ToggleProps, ToggleCombinedProps };
export default Toggle;
